import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'areaToSquareKmPipe',
})
export class AreaToSquareKmPipe implements PipeTransform {
  transform(area: number): number {
    if (!area) {
      return null;
    }

    return Number((area / (10 ** 6 * 2.58999)).toFixed(2));
  }
}
